var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 152,
    viewBox: "0 0 360 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M0 5.01137C0 4.17667 0.676661 3.5 1.51136 3.5L8.48864 3.5C9.32334 3.5 10 4.17666 10 5.01136V146.989C10 147.823 9.32334 148.5 8.48864 148.5H1.51136C0.676661 148.5 0 147.823 0 146.989V5.01137Z",
    fill: "#1554FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.0459 11.0114C16.0459 10.1767 16.7226 9.5 17.5573 9.5L31.5345 9.5C32.3692 9.5 33.0459 10.1767 33.0459 11.0114V140.989C33.0459 141.823 32.3692 142.5 31.5345 142.5H17.5573C16.7226 142.5 16.0459 141.823 16.0459 140.989V11.0114Z",
    fill: "#1554FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M39.0908 36.0114C39.0908 35.1767 39.7675 34.5 40.6022 34.5L68.5795 34.5C69.4142 34.5 70.0908 35.1767 70.0908 36.0114V115.989C70.0908 116.823 69.4142 117.5 68.5795 117.5H40.6022C39.7675 117.5 39.0908 116.823 39.0908 115.989V36.0114Z",
    fill: "#1554FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1488_539654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1367 46.0114C76.1367 45.1767 76.8134 44.5 77.6481 44.5L125.625 44.5C126.46 44.5 127.137 45.1767 127.137 46.0114V105.989C127.137 106.823 126.46 107.5 125.625 107.5H77.6481C76.8134 107.5 76.1367 106.823 76.1367 105.989V46.0114Z",
    fill: "#1554FF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M133.182 53.5114C133.182 52.6767 133.858 52 134.693 52H182.67C183.505 52 184.182 52.6767 184.182 53.5114V98.4886C184.182 99.3233 183.505 100 182.67 100H134.693C133.858 100 133.182 99.3233 133.182 98.4886V53.5114Z",
    fill: "#60C67C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.228 61.5114C190.228 60.6767 190.904 60 191.739 60L240.716 60C241.551 60 242.228 60.6767 242.228 61.5114V90.4886C242.228 91.3233 241.551 92 240.716 92H191.739C190.904 92 190.228 91.3233 190.228 90.4886L190.228 61.5114Z",
    fill: "#60C67C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M248.272 70.0114C248.272 69.1767 248.949 68.5 249.784 68.5H298.761C299.596 68.5 300.272 69.1767 300.272 70.0114V81.9886C300.272 82.8233 299.596 83.5 298.761 83.5H249.784C248.949 83.5 248.272 82.8233 248.272 81.9886V70.0114Z",
    fill: "#FF9960"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M306.318 76C306.318 75.1716 306.99 74.5 307.818 74.5H356.818C357.647 74.5 358.318 75.1716 358.318 76C358.318 76.8284 357.647 77.5 356.818 77.5H307.818C306.99 77.5 306.318 76.8284 306.318 76Z",
    fill: "#FF9960"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1488_539654",
    x: 70.0913,
    y: 38.4545,
    width: 63.0909,
    height: 78.1136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.02273
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.02273
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1488_539654"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.02273
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1488_539654",
    result: "effect2_dropShadow_1488_539654"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1488_539654",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.64d0abebdf305ce2537cf5865220940e.svg";
export { ForwardRef as ReactComponent };